import React, { useRef, useMemo } from 'react';
import { Modal, ModalHeader, ModalBody, Col, Card, CardBody } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import { useCheckout } from './useCheckout';
import CheckoutDisplay from './CheckoutDisplay';
import CheckoutForm from './CheckoutForm';
import moment from 'moment';
import "./checkoutModal.css"
import preventValueChangeOnScroll from '../../../helpers/PreventValueOnScroll';

const CheckoutModal = (props) => {
  const { isOpen, toggle, booking, onSuccess, t } = props;
  const refContainer = useRef();

  const checkout = useCheckout(booking, onSuccess);
  // console.log(checkout,"checkout");
  
  const checkoutCustomerColumn = useMemo(() => [
    {
      text: "Name",
      dataField: "name",
      headerStyle: { width: "5%" },
    },
    {
      text: "Customer Type",
      dataField: "customer_type",
      sort: false,
      headerStyle: { width: "8%" },
    },
    {
      text: "Customer Mobile",
      dataField: "mobile",
      sort: false,
      headerStyle: { width: "8%" },
    },
  ], []);

  const checkoutGameColumn = useMemo(() => [
    { dataField: "_id", hidden: true },
    {
      text: "S.N.",
      formatter: (cell, row, rowIndex) => rowIndex + 1,
      editable: false,
      headerStyle: (colum, colIndex) => {
        return { width: "4%" }
      },   
    },
    {
      text: "Name",
      dataField: "game.name",
      headerStyle: (colum, colIndex) => {
        return { width: "12%" }
      },   
      editable: false,
    },
    {
      text: "Start Time",
      dataField: "game.table_start_time",
      formatter: (cell, row) => moment(row.game.table_start_time).format("HH:mm"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" }
      },   
      editable: false,
    },
    {
      text: "Duration",
      dataField: "game.duration",
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "5%" }
      },   
      editable: false,
      validator: (newValue, row, column) => {
        if (+newValue < 30) {
          return {
            valid: false,
            message: "Minimum Playing Time is 30 Minutes",
          }
        }
        if (isNaN(newValue)) {
          return {
            valid: false,
            message: "Only numbers are allowed.",
          }
        }
        if (newValue % 1 !== 0) {
          return {
            valid: false,
            message: "Decimals not allowed.",
          }
        }
        return true
      },
      editorRenderer: (editorProps, value, row, column, rowIndex, columnIndex) => (
        <input
          style={{
            width: "50px",
            height: "40px",
            border: "1px solid lightGray",
            padding: "5px",
            borderRadius: "5px",
            boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
          }}
          type="number"
          defaultValue={value}
          onBlur={e => {
            checkout.handleDurationChange(e, rowIndex, row, editorProps)
            editorProps.onUpdate(+e.target.value)
          }}
          onFocus={e => e.target.select()}
          onWheel={preventValueChangeOnScroll}
          autoFocus
        />
      ),
    },
    {
      text: "End Time",
      dataField: "game.table_end_time",
      headerStyle: (colum, colIndex) => {
        return { width: "5%" }
      },   
      formatter: (cell, row) => row.game?.table_end_time ? moment(row.game.table_end_time).format("HH:mm"): "",
      headerStyle: { width: "5%" },
      editable: false,
    },
    {
      text: "Game Price",
      dataField: checkout.customerDetails[0]?.customer_type === "Friend"
        ? "game.price_for_friend"
        : checkout.customerDetails[0]?.customer_type === "Regular"
          ? "game.price_for_regular"
          : "game.price_for_vip",
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "5%" }
      },   
      editable: false,
    },
    {
      text: "Sub Total",
      dataField: "game.sub_total",
      sort: false,
       style: { textAlign: "right" } ,
       headerStyle: (colum, colIndex) => {
        return { width: "6%" ,textAlign: "right" }
      }, 
      editable: false,
    },
  ], [checkout.customerDetails, checkout.handleDurationChange]);

  const checkoutItemColumn = useMemo(() => [
    { dataField: "item_id", hidden: true },
    {
      text: "S.N.",
      formatter: (cell, row, rowIndex) => rowIndex + 1,
  headerStyle: (colum, colIndex) => {
        return { width: "5%" }
      },    },
    {
      text: "Name",
      dataField: "name",
  headerStyle: (colum, colIndex) => {
        return { width: "20%" }
      },    },
    {
      text: "Section",
      dataField: "section",
      sort: false,
  headerStyle: (colum, colIndex) => {
        return { width: "10%" }
      },    },
    {
      text: " Quantity",
      dataField: "quantity.in_unit",
      sort: false,
        formatter: (cell, row) => {
          return (
            <>
              {row.quantity?.in_unit +
                "  " +
                row.unit +
                " " +
                (row.sub_unit && row.sub_unit != "undefined"
                  ? row.quantity.in_sub_unit + " " + row.sub_unit
                  : "")}
            </>
          )
      },
        headerStyle: (colum, colIndex) => {
        return { width: "15%" }
      },
    },
    {
      text: "Price",
      dataField: "price",
    formatter: (cell, row, rowIndex) => {
      if (row.sub_unit && row.sub_unit !== "") {
        return `${row.price} / ${row.sub_unit}`;
      } else {
        return `${row.price} / ${row.unit}`;
      }
    },
    sort: false,
  headerStyle: (colum, colIndex) => {
        return { width: "10%" }
      },    },
    {
      text: "Sub Total",
      dataField: "sub_total",
      sort: false,
  style: { textAlign: "right" } ,
  headerStyle: (colum, colIndex) => {
        return { width: "10%" ,textAlign: "right" }
      },    
    },
  ], []);

  const bookedPackageDetailscolumns = useMemo(() => [
    { dataField: "_id", hidden: true },
    { dataField: "package_name", text: "Package ID" },
    {
      dataField: "item_details",
      text: "Item Details",
      formatter: (cell, row) => {
        if (cell.length === 0) return <div>No items found</div>
        return (
          <ul>
            {cell.map((item, index) => (
              <li key={index}>
                <strong>{item.name}</strong><br />
                Requested Quantity: {item.quantity.in_unit} {item.unit} {item.quantity.in_sub_unit} {item.sub_unit}<br />
                Section: {item.section}
              </li>
            ))}
          </ul>
        )
      },
    },
    {
      dataField: "game_details",
      text: "Game Details",
      formatter: cell => {
        if (cell.length === 0) return <div>No games found</div>
        return (
          <ul>
            {cell.map((game, index) => (
              <li key={index}>
                {t("Game")} : <strong>{game.name}</strong> <br />
                {t("Table")} : <strong>{game.table_number}</strong><br />
                {t("Duration")}: <b> {game.requested_duration} {t("minutes")}</b><br />
                {t("Game Time")} : <strong> {moment(game.table_start_time).format("HH:mm")} - {moment(game.table_end_time).format("HH:mm")} </strong>
              </li>
            ))}
          </ul>
        )
      },
    },
  ], [t]);

  return (
    <Modal size="lg" isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        <h5>{t("Check Out")} 🛒</h5>
      </ModalHeader>
      <ModalBody>
        <Col lg={12}>
          <Card>
            <CardBody>
              <CheckoutDisplay 
                {...checkout} 
                t={t} 
                checkoutCustomerColumn={checkoutCustomerColumn}
                checkoutGameColumn={checkoutGameColumn}
                checkoutItemColumn={checkoutItemColumn}
                bookedPackageDetailscolumns={bookedPackageDetailscolumns}
              />
              <br />
              <CheckoutForm {...checkout} t={t} refContainer={refContainer} />
            </CardBody>
          </Card>
        </Col>
      </ModalBody>
    </Modal>
  );
};

export default withTranslation()(CheckoutModal);
